import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c69f0ed8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = {
  ref: "datatable",
  class: "table table-striped table-hover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ชื่อ-นามสกุล"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สิทธิ์การใช้งาน"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ความรับผิดชอบ")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user me-2" }, null, -1))
const _hoisted_6 = { class: "badge bg-primary rounded-pill me-1" }
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AssignmentFormComponent = _resolveComponent("AssignmentFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userAssignments, (user, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: "row-hover",
              onClick: ($event: any) => (_ctx.selectedClick(user.id))
            }, [
              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, [
                _hoisted_5,
                _createTextVNode(_toDisplayString(user.name), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(user.roles.find(role => role.name === _ctx.mode)!.name), 1)
              ]),
              _createElementVNode("td", null, [
                (user.assignments.length == 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, " ยังไม่กำหนด "))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(user.assignments, (assignment, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "badge bg-success rounded-pill me-1",
                        key: index
                      }, _toDisplayString(assignment.name), 1))
                    }), 128))
              ])
            ], 8, _hoisted_4))
          }), 128))
        ])
      ], 512)
    ]),
    _createVNode(_component_AssignmentFormComponent, {
      ref: "assignmentForm",
      mode: _ctx.mode,
      selectedUser: _ctx.selectedUser
    }, null, 8, ["mode", "selectedUser"])
  ], 64))
}